import * as React from 'react';
import cn from 'clsx';
import { ArticleHeading1, UIText1 } from '@cian/ui-kit';

import { BigHeading } from '../../../../components/BigHeading';
import { IWithDeviceTypeProps, withDeviceType } from '../../../../utils/withDeviceType';
import { DealPriceRadioGroup } from '../DealPriceRadioGroup';
import { IGetPromoCalculatorResponse } from '../../../../types/promoCalculator';
import { DealPriceCard } from '../DealPriceCard';

import * as styles from './styles.css';

export type TCalculatorStages = {
  dealLocations: number;
  tariffs: number;
  settlementMethods: number;
};

interface IDealPriceCalculatorProps extends IWithDeviceTypeProps, IGetPromoCalculatorResponse {
  dealFormUrl: string;
  priceListUrl: string;
  calculatorIndexes: TCalculatorStages;
  handleChange(key: keyof TCalculatorStages, index: number): void;
  scrollToAdditionalServices(): void;
  onCreateDealButtonClick(): void;
}

const DealPriceCalculator: React.FC<React.PropsWithChildren<IDealPriceCalculatorProps>> = props => {
  const {
    deviceType,
    isPhone,
    dealFormUrl,
    priceListUrl,
    scrollToAdditionalServices,
    onCreateDealButtonClick,
    handleChange,
    title,
    dealLocationTitle,
    tariffTitle,
    settlementMethodTitle,
    calculatorIndexes,
    dealLocations,
  } = props;
  const Heading = isPhone ? ArticleHeading1 : BigHeading;

  const dealLocationIndex = calculatorIndexes.dealLocations;
  const selectedDealLocation = dealLocations[dealLocationIndex];
  const selectedTariff = selectedDealLocation.tariffs?.[calculatorIndexes.tariffs];
  const selectedSettlementMethod = selectedDealLocation.settlementMethods?.[calculatorIndexes.settlementMethods];

  return (
    <div className={cn(styles['container'], styles[deviceType])}>
      <div className={cn(styles['calculator'], styles[deviceType])}>
        <Heading as="h2" color="white_100">
          {title}
        </Heading>
        <div className={styles['details']}>
          <div className={styles['details-item']}>
            <UIText1 color="white_100">{dealLocationTitle}</UIText1>
            <DealPriceRadioGroup
              groupName="dealLocations"
              selectedItemIndex={calculatorIndexes.dealLocations}
              handleChange={handleChange}
              list={dealLocations}
            />
          </div>
          {selectedDealLocation.tariffs && selectedDealLocation.tariffs.length > 0 && (
            <div className={styles['details-item']}>
              <UIText1 color="white_100">{tariffTitle}</UIText1>
              <DealPriceRadioGroup
                groupName="tariffs"
                selectedItemIndex={calculatorIndexes.tariffs}
                handleChange={handleChange}
                list={selectedDealLocation.tariffs}
              />
            </div>
          )}
          {selectedDealLocation.settlementMethods && selectedDealLocation.settlementMethods.length > 0 && (
            <div className={styles['details-item']}>
              <UIText1 color="white_100">{settlementMethodTitle}</UIText1>
              <DealPriceRadioGroup
                groupName="settlementMethods"
                selectedItemIndex={calculatorIndexes.settlementMethods}
                handleChange={handleChange}
                list={selectedDealLocation.settlementMethods}
              />
            </div>
          )}
          <div className={styles['links-block']}>
            <div className={styles['button-wrap']}>
              <button className={styles['button']} type="button" onClick={scrollToAdditionalServices}>
                <UIText1 color="white_100">О способах вазиморасчётов</UIText1>
              </button>
            </div>
            <div className={styles['button-wrap']}>
              <a className={cn(styles['button'])} href={priceListUrl} target="_blank" rel="noreferrer">
                <UIText1 color="white_100">Все тарифы сделки</UIText1>
              </a>
            </div>
          </div>
        </div>
      </div>
      <DealPriceCard
        dealFormUrl={dealFormUrl}
        selectedDealLocation={selectedDealLocation}
        selectedTariff={selectedTariff}
        selectedSettlementMethod={selectedSettlementMethod}
        onCreateDealButtonClick={onCreateDealButtonClick}
      />
    </div>
  );
};

const DealPriceCalculatorWithDeviceType = withDeviceType(DealPriceCalculator);
export { DealPriceCalculatorWithDeviceType as DealPriceCalculator };
